module.exports = __webpack_public_path__ + "static/img/desicion1.c0310af0.png";